import { equipmentTypesApi } from '../api/modules/equipmentTypes.api';
import { getApiErrorMessage } from '../api/client';
import { USE_API } from '../config/api';
import { equipmentMasterSeed } from '../data/master/equipments';
import { equipmentTypeFromApi, equipmentTypeToApi, mapPaginated } from '../models';

export async function listEquipmentTypes(params = {}) {
  if (!USE_API) {
    let items = [...equipmentMasterSeed];
    if (params.search) {
      const q = String(params.search).toLowerCase();
      items = items.filter(
        (e) =>
          e.name?.toLowerCase().includes(q) ||
          e.equipmentId?.toLowerCase().includes(q) ||
          e.category?.toLowerCase().includes(q),
      );
    }
    const page = params.page || 1;
    const pageSize = params.pageSize || items.length || 50;
    const start = (page - 1) * pageSize;
    return { items: items.slice(start, start + pageSize), total: items.length, page, pageSize };
  }
  try {
    return mapPaginated(await equipmentTypesApi.list(params), equipmentTypeFromApi);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load equipment types'));
  }
}

export async function getEquipmentType(id) {
  if (!USE_API) {
    return equipmentMasterSeed.find((e) => e.equipmentId === id || e.id === id) || null;
  }
  try {
    return equipmentTypeFromApi(await equipmentTypesApi.getById(id));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to load equipment type'));
  }
}

export async function createEquipmentType(ui) {
  if (!USE_API) throw new Error('Create equipment type requires API mode');
  try {
    return equipmentTypeFromApi(await equipmentTypesApi.create(equipmentTypeToApi(ui)));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to create equipment type'));
  }
}

export async function updateEquipmentType(id, ui) {
  if (!USE_API) throw new Error('Update equipment type requires API mode');
  try {
    return equipmentTypeFromApi(await equipmentTypesApi.update(id, equipmentTypeToApi(ui)));
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to update equipment type'));
  }
}

export async function deleteEquipmentType(id) {
  if (!USE_API) throw new Error('Delete equipment type requires API mode');
  try {
    await equipmentTypesApi.remove(id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Failed to delete equipment type'));
  }
}
